export default function () {
  const priceToggle = document.querySelectorAll('.toggle-switch input[type=checkbox]');

  if (priceToggle !== null) {
    priceToggle.forEach((el) => {
      el.addEventListener('click', function (event) {
        for (var i = 0; i < priceToggle.length; i++) {
          priceToggle[i].checked = event.currentTarget.checked;
        }

        document.querySelector('body').classList.toggle('show-alternate-prices');
      });
    });
  }
}
